// Web-specific version of the useColorScheme hook
// This doesn't attempt to set colorScheme which causes errors in web environment

export function useColorScheme() {
    // For web, just return a fixed light theme and no-op functions
    return {
        colorScheme: 'light',
        isDarkColorScheme: false,
        // No-op functions that don't attempt to change anything
        setColorScheme: () => { },
        toggleColorScheme: () => { },
    };
} 